<template>
    <div>
        <b-row id="div-menu-bar" class="pt-2">
            <b-col cols="8" lg="2">
                <b-link to="/home"><img src="@/art/logo.png" class="fluid" /></b-link>
            </b-col>
            <b-col v-if="utils.isDesktop()" lg="8" class="text-center">
                <b-alert :show="utils.isDesktop()" variant="info" dismissible class="mt-2">
                    <span class="font-weight-bold">Alert: You are currently viewing our mobile site.  For a better experience, proceed to the Viva Learning desktop site.</span>
                    <br>
                    <b-link :href="getDesktopUrl">Go to the Viva Learning desktop site &raquo;</b-link>
                </b-alert>
            </b-col>
            <b-col cols="4" lg="2" class="text-right">
                <b-icon icon="list" class="border rounded p-2 font-weight-bold"
                font-scale="2.8"
                style=" display:inline-block;transform:scale(1.3,1); -webkit-transform:scale(1.3,1);"
                v-b-toggle.sidebar-menu
                ></b-icon>
            </b-col>
        </b-row>
        <b-sidebar
            id="sidebar-menu"
            title=""
            :backdrop-variant="variant2"
            backdrop
            right
            shadow="lg"
            @shown="shown"
        >
            <div v-if="!isLoggedIn">
                <div class="div-link-menu" @click.prevent="gotoPath('/home')">Home</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/login')">Login</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/webinars')">Upcoming Live CE Webinars</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/premium')">Premium CE Courses</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/ondemand')">On-Demand CE Webinars</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/podcasts')">Dental Podcasts</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/blog')">Dental Blog</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/drilldowns')">5-Minute Drill Down Videos</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/ebooks')">Dental eBooks</div>
                <!-- <div class="div-link-menu" @click.prevent="gotoPath('/tutorials')">Product Training</div> -->
                <div class="div-link-menu" @click.prevent="gotoPath('/about-us')"><b-icon icon="people-fill"></b-icon> About Us</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/support')"><b-icon icon="life-preserver"></b-icon> Support</div>
            </div>

            <div v-if="isLoggedIn">
                <div class="div-link-menu" @click.prevent="gotoPath('/home')">Home</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/webinars')">Upcoming Live CE Webinars</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/premium')">Premium CE Courses</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/ondemand')">On-Demand CE Webinars</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/podcasts')">Dental Podcasts</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/blog')">Dental Blog</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/drilldowns')">5-Minute Drill Down Videos</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/ebooks')">Dental eBooks</div>
                <!-- <div class="div-link-menu" @click.prevent="gotoPath('/tutorials')">Product Training</div> -->
                <hr class="hr-menu" size=1>
                <div class="div-link-menu" @click.prevent="gotoPath('/seats')">Reserved Seats</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/queue')">Watch Later</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/exams')">CE in Progress</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/completed')">CE Completed</div>
                <!-- <div class="div-link-menu" @click.prevent="gotoPath('/tutorial-history')">Viewed Tutorials</div> -->
                <hr class="hr-menu" size=1>
                <div class="div-link-menu" @click.prevent="gotoPath('/account')"><b-icon icon="person-fill"></b-icon> Account</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/about-us')"><b-icon icon="people-fill"></b-icon> About Us</div>
                <div class="div-link-menu" @click.prevent="gotoPath('/support')"><b-icon icon="life-preserver"></b-icon> Support</div>
                <div class="div-link-menu" @click.prevent="logout()">Logout</div>
            </div>

        </b-sidebar>
    </div>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

export default {
  name: "MenuSidebar",
  data() {
    return {
        debug: false,
        utils: utils,
        loading: false,
        variantBtn: 'dark',
        variant2: 'dark',
        variant: 'dark',
        variants: [
            'transparent',
            'white',
            'light',
            'dark',
            'primary',
            'secondary',
            'success',
            'danger',
            'warning',
            'info',
        ]
    }
  },
  computed: {
    isLoggedIn() {
        return this.$root.hasToken()
    },
    getDesktopUrl() {
        // Defined in main.js
        return this.$desktopUrl
    }
  },
  methods: {
    gotoPath(path) {
        let query = {}
        if (path == this.$router.currentRoute.path) {
            // console.log('route refresh')
            // use junk query var to force route refresh
            query = {j: (new Date).getTime()}
        }
        let route = { path: path, query: query }
        this.$router.push(route)
    },
    logout(e) {
      if (window.confirm('Are you sure you want to log out?')) {
        this.$router.push("/logout");
      }
    },
    shown() {  // when sidebar opened
        // console.log(`sidebar shown.  path: ${this.$route.path} fullPath ${this.$route.fullPath}`)
    },
    hidden() {
        // console.log(`sidebar hidden`)
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {}
};
</script>

<style scoped>
#div-menu-bar {
  background-color: #FFF;
  margin: -60px auto 10px auto;
}
.div-link-menu {
    /* background-color: #CCC; */
    background-color: #FFF;
    color: black;
    padding: 10px 0 10px 10%;
    margin: 0 0 1px 0;
    width: 100%;
}
.div-link-menu:hover {
    background-color: #888;
}

 .hr-menu {
    background-color: #000;
    padding: 0;
    margin: 0;
 }

.lnk-menu {
    background-color: #AAA;
}
.lnk-menu:hover {
    background-color: #CCC;
}
.lnk-menu:active {
    background-color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/MenuSidebar.vue